import {ReactElement, memo} from 'react';
import {Box} from '@mui/material';
import {Section as ISection} from 'interfaces/Project';
import {System} from 'interfaces/System';
import {UseConfiguratorActions} from 'views/Calculator/hooks/useConfigurator';
import SectionAccordion from './Section/SectionAccordion';

type Props = {
  sections: ISection[];
  configuratorActions: UseConfiguratorActions;
  systems: System[];
  onSaveProject: (onSuccess?: () => void) => void;
};

function ProjectSections({
  sections,
  configuratorActions,
  systems,
  onSaveProject
}: Props): ReactElement {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1.5}}>
      {sections.map((section, index) => (
        <SectionAccordion
          section={section}
          key={section.id}
          index={index}
          otherSections={sections.filter((s) => section.id !== s.id)}
          configuratorActions={configuratorActions}
          systems={systems}
          onSaveProject={onSaveProject}
        />
      ))}
    </Box>
  );
}

export default memo(ProjectSections);
